import React, { Component } from 'react';
import { muiWithStyles, MuiGrid, MuiButton, MuiAddCircle, MuiTypography } from '../../../ui/MaterialUIComponents';
import GradeList from './GradeList';
import theme from '../../../../assests/theme'
import lodashUtil from 'lodash';
import spinner from "../../../ui/icons/spinner.gif"
import PageHeaderComponent from '../../../ui/PageHeaderComponent'
import '../../../ui/scrollbarForLog.css'
import { toast } from 'react-toastify';
const styles = () => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(1),
    overflowX: 'auto',
  },
});


export class Grades extends Component {
  constructor(props) {
    super(props)
    this.state = {
      toggleChange: false,
    }
  }
  onHandleChangeOfGroupIds = (name, value, indexOfGrade, indexOfGroupId) => {
    let tempGradeList = this.props.gradelist
    let gradeObj = tempGradeList[indexOfGrade]
    gradeObj['groupNames'][indexOfGroupId] = value
    this.setState({
      gradelist: tempGradeList
    })

  }

  onHandleChangeOfHomeRoom = (name, value, indexOfGrade, indexOfGroupId) => {

    let tempGradeList = this.props.gradelist
    let gradeObj = tempGradeList[indexOfGrade]
    gradeObj['roomNames'][indexOfGroupId] = value
    this.setState({
      gradelist: tempGradeList
    })
  }

  //calculate the groups which are to be shown like 1-A, 1-B, etc.
  calculateGroupsAndRoomName = (value, gradeName) => {
    let groupNames = this.props.gradeMasterData.grades.slice(0, Number(value))
    let groups = []
    groupNames.map(element => {
      let group = {}
      group.groupName = element;
      group.roomName = gradeName + "-" + element
      groups.push(group)
    });
    return groups;
  }
  checkSubscriptionOnAdd = (props, numberOfGroups) => {
    if (props.activeSchool.license.status.toLowerCase() === "active" || props.activeSchool.license.status.toLowerCase() === "trial period") {
      let totalNumberOfGroups = Number(numberOfGroups);
      for (let i = 0; i < props.gradelist.length; i++) {
        totalNumberOfGroups += Number(props.gradelist[i].numberOfGroups)
      }
      if (totalNumberOfGroups <= props.activeSchool.license.sectionsQuantity) {
        return { isAllowed: true, numberOfGroups: numberOfGroups };
      } else if (props.activeSchool.license.sectionsQuantity - (totalNumberOfGroups - numberOfGroups) > 0) {
        return { isAllowed: true, numberOfGroups: props.activeSchool.license.sectionsQuantity - (totalNumberOfGroups - numberOfGroups) };
      } else {
        return { isAllowed: false, numberOfGroups: 0 };
      }
    } else {
      return { isAllowed: false, numberOfGroups: 0 };
    }
  }
  checkSubscriptionOnEdit = (props) => {

    if (props.activeSchool.license.status.toLowerCase() === "active" || props.activeSchool.license.status.toLowerCase() === "trial period") {
      let totalNumberOfGroups = 0;
      for (let i = 0; i < props.gradelist.length; i++) {
        totalNumberOfGroups += Number(props.gradelist[i].numberOfGroups)
      }
      if (totalNumberOfGroups <= props.activeSchool.license.sectionsQuantity) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  renderAddRow = () => {
    let gradeList = this.props.gradelist;
    let gradeMasterData = this.props.gradeMasterData;
    let gradeName;
    let levelName;
    let numberOfGroups;
    let groups;
    const i18n = this.props.i18n

    if (gradeList.length < 1) {
      gradeName = gradeMasterData.gradeNumber[0];
      levelName = gradeMasterData.gradeLevel[0];
      numberOfGroups = gradeMasterData.numberOfGroups[0];
      groups = this.calculateGroupsAndRoomName(numberOfGroups, gradeName);
    } else {

      let previousGradeNameIndex = lodashUtil.indexOf(gradeMasterData.gradeNumber, gradeList[gradeList.length - 1].gradeName);
      gradeName = gradeMasterData.gradeNumber[previousGradeNameIndex + 1];
      levelName = gradeList[gradeList.length - 1].levelName;
      numberOfGroups = gradeList[gradeList.length - 1].numberOfGroups;

    }
    let licenceObj = this.checkSubscriptionOnAdd(this.props, numberOfGroups)
    if (licenceObj.isAllowed) {
      groups = this.calculateGroupsAndRoomName(licenceObj.numberOfGroups, gradeName);
      let activeGrade = {
        id: gradeList.length + 1,
        gradeName: gradeName,
        levelName: levelName,
        numberOfGroups: licenceObj.numberOfGroups,
        groups: groups,
      }

      gradeList.push(activeGrade)
      this.updateData()
      this.setState({
        gradelist: gradeList,
        activeGrade: activeGrade
      })
    } else {
      toast(i18n.grades.maxNumberOfGroupsExceedError)
      this.setState({ toggleChange: !this.state.toggleChange })
    }

  }
  updateData = () => {
    if (!this.props.confirmDialog.isChanged) {
      this.props.confirmDialog.isChanged = true
    }
    this.setState({
      toggleChange: !this.state.toggleChange
    })
  }
  render() {
    const { classes, i18n } = this.props
    if (this.props.gradeMasterData.gradeLevel === undefined || this.props.updateSchoolinformationInProgress === true) {
      return <MuiGrid container xs={12} alignItems="stretch" justify='center' alignContent='center' direction='column' ><img src={spinner} alt="none" style={theme.spinnerImgStyle} /></MuiGrid>
    }
    return (
      <MuiGrid container xs={12} >

        <PageHeaderComponent {...this.props} title={i18n.grades.title} subTitle={i18n.grades.tabDescription} />

        <MuiGrid container xs={12} >
          {/* <MuiGrid container xs={12} style={theme.tableHeaderStyle} > */}
          <MuiGrid container xs={12} direction='row' style={theme.tableHeaderStyle}>
            <MuiGrid item xs={2} >
              <MuiTypography style={theme.tableHeaderTextStyle}>
                {i18n.grades.gradeLevel}
              </MuiTypography></MuiGrid>
            <MuiGrid item xs={2}>
              <MuiTypography style={theme.tableHeaderTextStyle}>
                {i18n.grades.gradeNumber}
              </MuiTypography></MuiGrid>
            <MuiGrid item xs={2}>
              <MuiTypography style={theme.tableHeaderTextStyle}>
                {i18n.grades.numberOfGroups}
              </MuiTypography></MuiGrid>
            <MuiGrid item xs>
              <MuiTypography style={theme.tableHeaderTextStyle}>
                {i18n.grades.groupIdAndHomeRoom}
              </MuiTypography>
            </MuiGrid>
          </MuiGrid>
          <MuiGrid container xs={12} id='scrollStyle' style={{ maxHeight: '62vh', overflowY: 'auto' }}>
            {this.props.gradelist.map((grade, index) =>
              <MuiGrid item xs={12} id="grid">
                <GradeList
                  index={index}
                  grade={grade}
                  {...this.props}
                  onHandleChangeOfGroupIds={this.onHandleChangeOfGroupIds}
                  onHandleChangeOfHomeRoom={this.onHandleChangeOfHomeRoom}
                  handleOnChange={this.props.handleOnChange}
                  removeGradeFromGradeList={this.props.removeGradeFromGradeList}
                  calculateGroupsAndRoomName={this.calculateGroupsAndRoomName}
                  checkSubscriptionOnAdd={this.checkSubscriptionOnAdd}
                  checkSubscriptionOnEdit={this.checkSubscriptionOnEdit}
                  updateData={this.updateData}
                />
              </MuiGrid>
            )}</MuiGrid>

          <MuiGrid container xs={12} onClick={this.props.gradelist.length < this.props.gradeMasterData.gradeNumber.length ? () => this.renderAddRow() : null} style={theme.gridActionContainerStyleForStickyButton} justify="center" alignItems="center">
            <MuiGrid item >
              <MuiAddCircle style={{ color: theme.palette.orange }} fontSize='large' />
            </MuiGrid>

            <MuiGrid item>
              <MuiTypography style={theme.addMoreStyle} >
                {i18n.grades.addMoreGrades}
              </MuiTypography>
            </MuiGrid>
          </MuiGrid>
        </MuiGrid>
        {/* </MuiGrid> */}

        <MuiGrid container xs={12} style={{ height: '2vh' }}></MuiGrid>
        <MuiGrid container xs={12} justify="flex-end" >
          <MuiButton
            disabled={!this.props.confirmDialog.isChanged}
            style={!this.props.confirmDialog.isChanged ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle}
            onClick={() => { this.props.onClickOfSave() }}>
            {i18n.commonTexts.save}
          </MuiButton>
        </MuiGrid>
      </MuiGrid>
    )
  }
}

export default muiWithStyles(styles)(Grades)
